if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        // Dough Dorks performance: the product page serves a lightweight
        // modal preview. Restore the full-resolution Shopify image only when
        // the customer actually opens the zoom/lightbox.
        const hiResImages = [];
        if (activeMedia.matches && activeMedia.matches('img[data-dd-hires-src]')) hiResImages.push(activeMedia);
        activeMedia.querySelectorAll('img[data-dd-hires-src]').forEach((image) => hiResImages.push(image));
        hiResImages.forEach((image) => {
          const hiResSrc = image.dataset.ddHiresSrc;
          if (!hiResSrc) return;
          image.removeAttribute('srcset');
          image.src = hiResSrc;
          image.removeAttribute('data-dd-hires-src');
        });

        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
